import { render, staticRenderFns } from "./ThirdPartyAdd.vue?vue&type=template&id=700c83f6&"
import script from "./ThirdPartyAdd.vue?vue&type=script&lang=ts&"
export * from "./ThirdPartyAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('700c83f6')) {
      api.createRecord('700c83f6', component.options)
    } else {
      api.reload('700c83f6', component.options)
    }
    module.hot.accept("./ThirdPartyAdd.vue?vue&type=template&id=700c83f6&", function () {
      api.rerender('700c83f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/thirdParty/ThirdPartyAdd.vue"
export default component.exports